var transactionDisputeStatusTitle = {
    actionRequested: 'Additional information requested',
    cancelationProcessing: "We're processing your cancelation request",
    disputeApproved: 'Your dispute was approved',
    disputeCanceled: 'Your dispute was canceled',
    disputeCompleted: 'Your dispute was completed',
    disputeDenied: 'Your dispute was denied',
    new: 'Your dispute was opened',
    temporaryCredit: 'We applied a temporary credit',
    underReview: 'Your dispute is under review'
};
export default transactionDisputeStatusTitle;
//# sourceMappingURL=transactionDisputeStatusTitle.js.map